import { render, staticRenderFns } from "./Wdsc.vue?vue&type=template&id=0b7a3085&scoped=true&"
import script from "./Wdsc.vue?vue&type=script&lang=js&"
export * from "./Wdsc.vue?vue&type=script&lang=js&"
import style0 from "./Wdsc.vue?vue&type=style&index=0&id=0b7a3085&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7a3085",
  null
  
)

export default component.exports